import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setInvalidToken } from "../../../../../redux/features/main/invalidTokenSlice";
import {
  changePhotoProfile,
  detailProfile,
  getAchievements,
  getCertificate,
  getAdditional,
  getCompletedJourneyProfile,
} from "../../../../../api/repositories";
import moment from "moment";
import { encryptData, decryptData } from "../../../../../utils";
// import { additionalData } from "../constant_additional";
import { certif } from "../constant_certif";

const useActions = (loading, userData, listJourney, mainState) => {
  const remoteProperty = useSelector((state) => state.remote.remoteProperty);
  const dispatch = useDispatch();
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [detailUser, setDetailUser] = useState([]);
  const [journey, setJourney] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [loadingCertif, setLoadingCertif] = useState(true);
  const [loadingAchievement, setLoadingAchievement] = useState(true);
  const [loadingAdditional, setLoadingAdditional] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [loadingJourney, setLoadingJourney] = useState(true);

  const fetchDetailProfile = async (e) => {
    const userIdEncrypt = encryptData(e.userId)
    try {
      setLoadingDetail(true);
      const resultData = await detailProfile(userIdEncrypt);

      const { status, data } = (remoteProperty?.isEncryptionEnabled)
        ? decryptData(resultData.response)
        : resultData;

      dispatch(setInvalidToken(status));
      if (status == 200) {
        setDetailUser(data);
      }
    } catch (err) {
      // console.log(err);
      setDetailUser([]);
    } finally {
      setLoadingDetail(false);
    }
  };

  const handleChangePicture = async (image) => {
    if (image) {
      const dataAPI = new FormData();
      dataAPI.append("os", "android");
      dataAPI.append("image", image);

      try {
        const { status, message } = await changePhotoProfile({ data: dataAPI });
        dispatch(setInvalidToken(status));
        if (status == 200) {
          mainState.setFlagUpdatePicture(!mainState.flagUpdatePicture);
          fetchDetailProfile(userData);
        }
      } catch (err) {
        // console.log(err);
      }
    }
  };

  const fetchAdditional = async (id) => {
    try {
      setLoadingAdditional(true);
      const { status, data } = await getAdditional(parseInt(id));
      dispatch(setInvalidToken(status));
      // const { status, data } = additionalData
      if (status == 200) {
        setAdditional(data);
        // setAdditional([])
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingAdditional(false);
    }
  };

  const fetchListAchievements = async () => {
    try {
      setLoadingAchievement(true);
      const { status, data } = await getAchievements();
      dispatch(setInvalidToken(status));
      if (status == 200) {
        setAchievements(data);
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingAchievement(false);
    }
  };

  const fetchListCertificates = async () => {
    try {
      setLoadingCertif(true);
      // const { status, data } = certif;
      const { status, data } = await getCertificate();
      dispatch(setInvalidToken(status));
      if (status == 200) {
        const filterCertif = sortCertificate(data);
        setCertificate(filterCertif);
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingCertif(false);
    }
  };

  const sortCertificate = (data) => {
    return [].concat(...data.map(({ certificates }) => certificates || []));
  };

  const fetchListCompletedJourney = async () => {
    setLoadingJourney(true);
    try {
      const { status, data } = await getCompletedJourneyProfile();
      dispatch(setInvalidToken(status));
      if (status == 200) {
        filterJourney(data);
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingJourney(false);
    }
  };

  const filterJourney = (data) => {
    const FinishedCat = data
      // .filter((item) => item.is_new === 0 && item.is_completed === 1)
      .sort((a, b) => {
        return moment(a.completed_date).diff(b.completed_date);
      })
      .reverse();

    setJourney([...FinishedCat]);
    setLoadingJourney(false);
  };

  useEffect(() => {
    if (loading == false) {
      fetchListCertificates();
      fetchDetailProfile(userData);
      fetchListAchievements();
      fetchAdditional(userData.userId);
      fetchListCompletedJourney();
    }
  }, [loading]);

  useEffect(() => {
    if (
      loadingDetail == false &&
      loadingCertif == false &&
      loadingAchievement == false &&
      loadingJourney == false
    ) {
      setLoadingProfile(false);
    }
  }, [loadingDetail, loadingCertif, loadingAchievement, loadingJourney]);

  return {
    loadingProfile,
    detailUser,
    journey,
    achievements,
    certificate,
    handleChangePicture,
    additional,
    fetchDetailProfile,
    fetchAdditional,
    loadingJourney,
    loadingAchievement,
    loadingCertif,
    loadingDetail,
    loadingAdditional,
    fetchListCompletedJourney,
    fetchListCertificates,
    fetchListAchievements,
  };
};

export default useActions;
